<template>
  <ion-card>
    <ion-card-content>
      <ion-item class="header ion-margin-bottom">
        <h1>Device: {{ device.serialNumber }}</h1>
      </ion-item>

      <ion-item>
        <ion-label position="floating">
          Room
        </ion-label>
        <ion-select-vue 
          v-model="device.group.uuid"
          interface="popover"
        >
          <ion-select-option 
            v-for="deviceGroup in deviceGroups" 
            :key="deviceGroup.uuid"
            :value="deviceGroup.uuid"
          >
            {{ deviceGroup.name }}
          </ion-select-option>
        </ion-select-vue>
      </ion-item>
    </ion-card-content>

    <ion-card-footer>
      <ion-button 
        expand="full"
        :disabled="busy"
        @click="save"
      >
        <ion-spinner v-if="busy" />
        <template v-else>
          Save
        </template>
      </ion-button>
    </ion-card-footer>
  </ion-card>
</template>

<script>
import { modalController } from '@modus/ionic-vue'

import { mapGetters } from 'vuex'
import { IonSelectVue } from '@modus/ionic-vue'

import store from '../../state'

export default {
  components: {
    IonSelectVue
  },
  props: {
    serialNumber: {
      type: String,
      required: true
    },
    deviceSerialNumber: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      busy: false,
      unassigned: {
        uuid: '',
        name: 'Unassigned'
      },
      oldGroup: undefined
    }
  },
  computed: {
    ...mapGetters([
      'getBridgeBySerial',
      'getDeviceBySerial'
    ]),
    bridge() {
      return this.getBridgeBySerial(this.serialNumber)
    },
    device() {
      return this.getDeviceBySerial(this.serialNumber, this.deviceSerialNumber)
    },
    deviceGroups() {
      const deviceGroups = [...this.bridge.deviceGroups]
      const unassigned = deviceGroups.find(deviceGroup => deviceGroup.name === this.unassigned.name)

      if(!unassigned) {
        deviceGroups.unshift(this.unassigned)
      }

      return deviceGroups
    },
  },
  created() {
    // set manually in modal
    this.$store = store
    this.oldGroup = this.device.group.uuid
  },
  methods: {
    save() {
      const serialNumber = this.serialNumber
      const deviceSerialNumber = this.deviceSerialNumber
      const group = this.device.group.uuid
      const oldGroup = this.oldGroup

      this.busy = true

      this.$store.dispatch('assignDevice', { serialNumber, deviceSerialNumber, group, oldGroup })
        .then(() => modalController.dismiss())
        .finally(() => this.busy = false)
    }
  }
}
</script>

<style scoped>
ion-card {
  margin:0;
}

.header {
  --padding-start:0;
}
</style>

<style>
.update-device-modal .modal-wrapper {
  background:none;
}
</style>